import { fromJS } from 'immutable';
import { handleActions } from 'redux-actions';
import * as s from './selectors.js';

import mapping from '~/utils/mapping.json';


export const defaultState = fromJS({
    env: {
        node: null,
        op: null, // Operating Environent
    },
    feature_flags: [],
    search: {
        activePage: 1,
        perPage: mapping.search.items_per_page[0].value,
        results: null,
        sortByField: 'name',
        isSortReverse: false,
        isLoading: false,
    },
    affiliate_selector: {
        selectedItems: [],
        isOpen: false,
        confirmedItems: [],
    },
    types: {
        organization: [],
    },
});

export default handleActions({
    APP: {
        ENV: {
            NODE: {
                SET: (state, { payload }) => state.setIn(['env', 'node'], payload || null),
            },
            OP: {
                SET: (state, { payload }) => state.setIn(['env', 'op'], payload || null),
            },
        },

        FEATURE_FLAGS: {
            SET: (state, { payload }) => state.set('feature_flags', fromJS(payload)),

            RESET: state => state.set('feature_flags', defaultState.get('feature_flags')),
        },

        SEARCH: {
            RESULTS: {
                SET: (state, { payload }) => state
                    .set('search', defaultState.get('search'))
                    .setIn(['search', 'results'], fromJS(payload)),

                CLEAR: state => state.set('search', defaultState.get('search')),
            },

            ITEMS_PER_PAGE: {
                SET: (state, { payload }) => state
                    .setIn(['search', 'perPage'], fromJS(payload))
                    .setIn(['search', 'activePage'], 1),
            },

            ACTIVE_PAGE: {
                SET: (state, { payload }) => {
                    window.scrollTo(0, 0);
                    return state.setIn(['search', 'activePage'], fromJS(payload));
                },
            },

            SORT_BY: {
                SET: (state, { payload }) => {
                    const sortByField = s.getSortByField(state);
                    const isSortReverse = s.getIsSortReverse(state);

                    const searchState = s.getSearch(state).merge({
                        sortByField: payload,
                        isSortReverse: payload === sortByField ? !isSortReverse : isSortReverse,
                        activePage: 1,
                    });

                    return state.set('search', searchState);
                },
            },
            ISLOADING: {
                SET: (state, { payload }) => state.setIn(['search', 'isLoading'], fromJS(payload)),
            },
        },
        AFFILIATE_SELECTOR: {
            IS_OPEN: {
                SET: (state, { payload }) => state.setIn(['affiliate_selector', 'isOpen'], fromJS(payload)),
            },
            SELECTED_ITEMS: {
                SET: (state, { payload }) => state.setIn(['affiliate_selector', 'selectedItems'], fromJS(payload)),
            },
            CONFIRMED_ITEMS: {
                SET: (state, { payload }) => state.setIn(['affiliate_selector', 'confirmedItems'], fromJS(payload)),
            },
        },
        TYPES: {
            ORGANIZATION: {
                SET: (state, { payload }) => state.setIn(['types', 'organization'], fromJS(payload)),
            },
        },
    },
}, defaultState);
